var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-py-12 tw-cols tw-justify-center tw-items-center",class:{ 'main-hero-section': _vm.isHome, 'hero-section-area': !_vm.isHome }},[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }